import { ClientsService } from '../services'

export default (filters) => {
  return new Promise(async (resolve, reject) => {
    await ClientsService.getFiltersCLClientes(filters)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
